<style scoped>
  .post-wrapper {
    background-color: white;
    height: 100vh;
    width: 100%;
    overflow: hidden;
  }
  .post-body {    
    margin-top: 80px;
    height: calc(100% - 150px);
    width: 100%;
    overflow-y: scroll;
    padding: 15px;
  }
  .post-footer {
    position: relative;
    bottom: 0;
    height: 70px;
    width: 100%;
    border-top: 1px solid rgb(190, 190, 190);
    padding: 10px;
    display: flex;
  }

  textarea {
    height: 45px !important;
    border: none;
    overflow: hidden;
    outline: none;
    width:100%; 
    padding:10px 0 0 10px; 
    height:80%; 
    margin: 0 5px 0 5px; 
    resize: none;   

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;    
  }   
  Button {
    padding:0px !important;
  }
</style>


<template>
  <div class="post-wrapper">
    <BeFirstToComponent v-show="!hasComment">Be the first to reply</BeFirstToComponent>
    <div class="post-body">
      <PostComponent v-for="(activity,indexReply) in activities"
        :key="indexReply" 
        :type="'reply'"         
        :index="index"
        :indexReply="indexReply"      
        :activityId="activity.id"
        :userAvatar="activity.user.avatar"
        :userDisplayName="activity.user.display_name"
        :content="activity.content"
        :updatedAt="activity.updated_at"
        :likesTotal="activity.likes.total"
        :userId="activity.user.id"
        :indentIt=false
        :hasReply=false
        > 
      </PostComponent>      
    </div>
    <div class="post-footer">
      <Avatar size="large" :src="userInfo.avatar" style="height:40px; width:50px; margin:-5px 0 0 5px;" ></Avatar>
      <textarea v-model="reply" id="reply" placeholder="Write a reply" cols="30" rows="2" style=""></textarea>
      <Button v-show="hasReply && !isReplying" @click="postReply()" type="text" ><Icon type="android-send" size="30"/> </Button>
      <Button v-show="!hasReply && !isReplying" type="text" disabled><Icon type="android-send" size="30"/> </Button>
      <Button v-show="hasReply && isReplying" type="text" loading disabled></Button>            
    </div>    
  </div>
</template>


<script>
import BeFirstToComponent from '@/components/BeFirstToComponent';
import PostComponent from '@/components/PostComponent';

export default {
  name: 'FeedSingleReplyComponent',  
  components: {
    BeFirstToComponent, PostComponent
  },  
  data() {
    return {
      hasReply: false,
      reply: ""
    }
  },  
	watch: { 
		"reply": function() {
			if (this.reply!=undefined) {
				this.hasReply = this.reply.trim().length>0;
			}
		}
	},  
  computed: {
    userInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    index: {
      get() {
        return parseInt(this.$route.params.index);
      }
    },
    activities: {
      get() {
        var list = this.$store.state.feed.feedSingleItemActivities.activities;
        if (list!=undefined) {
          return list[this.index].comment.comments;
        }
      }
    },
		hasComment: {
			get() {
				var has = false;
				if (this.activities!=undefined) {
					has = this.activities.length>0
				}
				return has;				
			}
		},  
    isReplying: {
      get() {
        return this.$store.state.feed.isReplying;
      }
    }   
  },
  methods: { 
    postReply() {
      var index =this.$route.params.index;
      var param = {
        content: this.reply,
        item_id: this.$store.state.feed.feedSingleItemActivities.activities[index].id,
        index: index
      };
      this.$store.dispatch("feed/postFeedSingleReply", param);
      this.reply="";  
    }
  }

}

</script>
